import {IonicModule} from '@ionic/angular';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {HttpClientModule} from '@angular/common/http';
import { DatasourceDesignerModal } from './datasource-designer/datasource-designer.modal';
import { DatasourceFormModalPage } from './datasource-form-modal/datasource-form-modal.page';
import { MaterialModule } from '../material.module';
import { AbwDatatableModule } from '../abw-datatable/abw-datatable.module';
import { AbwConfirmDialogModule } from '../abw-confirm-dialog/abw-confirm-dialog.module';
import { DatasourceColumnsMappingComponent } from './datasource-columns-mapping/datasource-columns-mapping.component';
import { DatasourceDesignerJointureModalComponent } from './datasource-designer/datasource-designer-jointure-modal/datasource-designer-jointure-modal.component';
import { DatasourceDesignerColumnFormModal } from './datasource-designer/datasource-designer-column-form-modal/datasource-designer-column-form-modal.component';
import { DatasourceDesignerEditDatasModal } from './datasource-designer/datasource-designer-edit-datas-modal/datasource-designer-edit-datas-modal.component';
import { DatasourceColumnsInputGridMappingComponent } from './datasource-columns-inputgrid-mapping/datasource-columns-inputgrid-mapping.component';
import { AbwMatDatatableModule } from '../abw-mat-datatable/abw-mat-datatable.module';

@NgModule({
    declarations: [DatasourceDesignerModal, DatasourceDesignerColumnFormModal, DatasourceFormModalPage, DatasourceColumnsMappingComponent, DatasourceDesignerJointureModalComponent, DatasourceDesignerEditDatasModal, DatasourceColumnsInputGridMappingComponent],
    exports: [DatasourceDesignerModal, DatasourceDesignerColumnFormModal, DatasourceColumnsMappingComponent, DatasourceDesignerJointureModalComponent, DatasourceDesignerEditDatasModal, DatasourceColumnsInputGridMappingComponent],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        HttpClientModule,
        MaterialModule,
        AbwDatatableModule,
        AbwConfirmDialogModule,
        AbwMatDatatableModule
    ],
    entryComponents: [
        DatasourceDesignerColumnFormModal, 
        DatasourceDesignerModal,
        DatasourceFormModalPage,
        DatasourceDesignerJointureModalComponent,
        DatasourceDesignerEditDatasModal
    ],
})
export class DatasourceComponentsModule {}